/* eslint-disable no-unused-vars */

export enum uploadConstant {
  GET_UPLOAD_URL = 'GET_UPLOAD_URL',
  UPDATE_UPLOAD_URL = 'UPDATE_UPLOAD_URL',
  UPDATE_UPLOAD_STATUS = 'UPDATE_UPLOAD_STATUS',
  UPDATE_FILES = 'UPDATE_FILES',
  UPDATE_UPLOADING_STATS = 'UPDATE_UPLOADING_STATS',
  UPLOAD_SUCCESS = 'UPLOAD_SUCCESS',
  UPLOAD_FAIL = 'UPLOAD_FAIL',
  START_UPLOAD = 'START_UPLOAD',
  RESET_UPLOAD = 'RESET_UPLOAD',
  UPLOAD_FILE = 'UPLOAD_FILE',
  COMPLETE_UPLOAD = 'COMPLETE_UPLOAD',
  COMPLETE_UPLOAD_FILE = 'COMPLETE_UPLOAD_FILE',
}
